<template>
  <div id="mian">
    <div class="slogn">
      <img src="~assets/img/slogn.png"
           alt />
    </div>
    <!-- ------------ -->
    <div>
      <div class="login"
           style>
        <div class="fromDiv">
          <h2 class="tital-text">注册你的账号</h2>
          <div>
            <el-input v-model="formData.username"
                      placeholder="请输入用户名"
                      prefix-icon="el-icon-user"></el-input>
          </div>
          <div style="margin-top: 20px">
            <el-input placeholder="请输入密码"
                      v-model="formData.password"
                      prefix-icon="el-icon-unlock
                    "
                      show-password></el-input>
          </div>
          <div style="margin-top: 20px">
            <el-input placeholder="请再次输入密码"
                      v-model="formData.passwords"
                      prefix-icon="el-icon-unlock
                    "
                      show-password></el-input>
          </div>
          <div style="margin-top: 20px">
            <el-input placeholder="请输入邮箱"
                      v-model="formData.email"
                      prefix-icon="el-icon-message
                    "></el-input>
          </div>
          <div style="margin-top: 20px">
            <el-button @click.prevent="handleRegister()"
                       style="width: 100%"
                       type="primary">注册</el-button>
          </div>
          <div class="text-bottom"
               style="margin-top: 15px; margin-bottom: 35px">
            <div style="float: left; display: flex">
              <p class="account-have"
                 style="font-size: 13px">已有账号，</p>
              <el-link class="account-have"
                       @click="handleToLogin()"
                       style="font-size: 13px"
                       type="primary">登陆</el-link>
            </div>
            <div class="login-text">
              <p class="account-have"
                 style="font-size: 13px">
                注册即代表您已阅读并同意《
              </p>
              <el-link class="account-have"
                       style="font-size: 13px"
                       type="primary">用户协议</el-link>
              <p class="account-have"
                 style="font-size: 13px">》</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 备案信息 -->
    <div>
      <!-- 备案信息 -->
      <copy-right></copy-right>
    </div>
  </div>
</template>

<script>
import CopyRightAndWebInfor from '../../components/common/CopyRightAndWebInfor'

export default {
  name: 'Register',
  components: {
    'copy-right': CopyRightAndWebInfor,
  },
  data() {
    return {
      formData: {
        username: '',
        password: '',
        passwords: '',
        email: '',
      },
    }
  },
  methods: {
    // getCookie(name) {
    //     document.cookie.match("\\b" + name + "=[^;]*\\b");
    //     return r ? r[1] : undefined;
    //     },
    handleToLogin() {
      this.$router.push({ path: '/login' })
    },
    handleRegister() {
      this.$http.post('register', this.formData).then((res) => {
        console.log(res)
        // 0 注册成功
        // 4103 参数错误
        // 4003 用户名或邮箱已存在
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.$message({
            message: errmsg,
            type: 'success',
          })
          this.$router.push({ path: '/home' })
        } else if (errno == '4103') {
          this.$message.error({
            message: errmsg,
            type: 'warning',
          })
        } else if (errno == '4003') {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 之后需要想到的问题呢就是，什么时候掉这个函数，答点击登陆按钮的时候调用。
  },
}
</script>

<style>
#mian {
  position: absolute;
  background-color: #ff5421;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-size: cover;
}

.slogn img {
  position: absolute;
  border: 2px solid rgb(255, 255, 255);
  margin-top: 15%;
  margin-left: 10%;
  width: 30%;
  height: auto;
}

.login {
  position: relative;
  left: 50%;
  padding: 20px 50px;
  background: #ffffff;
  border-radius: 5px;

  position: relative;

  margin-top: 10%;
  margin-left: 5%;
  margin-right: auto;
  background: #fff;
  margin-bottom: 50px;
}

.forDiv h2 {
  padding: 10px 0 20px;
  font-size: 20px;
  color: #545454;
}

.tital-text {
  text-align: center;
  font-size: 23px;
  margin: 20px 0 10px;
  padding: 10px 0 20px;
  font-style: unset;
  font-family: Arial, Helvetica, sans-serif;
  color: #545454;
}

.login-text {
  display: flex;
  float: right;
}

.account-have {
  font-family: monospace;
  font-weight: normal;
}
</style>